import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface DashEmptyStateProps {
  icon: IconDefinition;
  title: string;
  description?: string;
}

const DashEmptyState = ({ icon, title, description }: DashEmptyStateProps) => (
  <div className="dash-empty">
    <div className="dash-empty-icon">
      <FontAwesomeIcon icon={icon} />
    </div>
    <h6>{title}</h6>
    {description && <p>{description}</p>}
  </div>
);

export default DashEmptyState;
